import React from "react"
import logo from '../images/litc.svg' // Adjust the path to your SVG file

const Logo = () => {
    return (
        <img src={logo} alt="Logo" className="w-7 md:w-12 h-7 md:h-12" />
    )
}

export default Logo